import { expected } from '@aloft/toolkit-shared';

import { Provider as ReduxProvider } from 'react-redux';
import { Outlet, useParams } from 'react-router';

import { store } from '../../redux/store.ts';
import { Tkv2ControllerReferenceBarContext } from '../Tkv2ControllerReferenceBarContext.ts';
import { CraftsmanOrderSyncDriver } from '../craftsmanOrderSync/CraftsmanOrderSyncDriver.tsx';
import { useNewTkv2ReferenceBarUserInterface } from '../hooks/useNewTkv2ReferenceBarUserInterface.ts';

export const Tkv2ReferenceViewRouteElement = () => {
  const { orderId: orderID, orderType } = useParams();
  const referencebar = useNewTkv2ReferenceBarUserInterface();

  return (
    <>
      <ReduxProvider store={store}>
        <Tkv2ControllerReferenceBarContext.Provider value={referencebar}>
          <Outlet />
        </Tkv2ControllerReferenceBarContext.Provider>
      </ReduxProvider>
      {orderID && orderType === 'craftsman' && <CraftsmanOrderSyncDriver orderID={expected(orderID)} />}
    </>
  );
};
